  export default new Proxy({}, {
    get(_, key) {
      throw new Error(`Module "node:path" has been externalized for browser compatibility. Cannot access "node:path.${key}" in client code.  See https://vite.dev/guide/troubleshooting.html#module-externalized-for-browser-compatibility for more details.`)
    }
  })